// extracted by mini-css-extract-plugin
export default {"section":"LoyaltyProgramTemplate_section__d+AJD","title":"LoyaltyProgramTemplate_title__xWEFX","wrapper":"LoyaltyProgramTemplate_wrapper__G1920"};